import { TinyMceEditor } from './tiny-mce-editor.interface'
import { TinyMce } from './tiny-mce.interface'

import * as TinyMceGlobal from 'tinymce/tinymce'

import 'tinymce/themes/modern'
import 'tinymce/plugins/link'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/table'
import 'tinymce/plugins/image'

import 'tinymce-formula/plugin'

export const TinyMceModule: TinyMce = TinyMceGlobal
export const Editor: { new(): TinyMceEditor } = TinyMceModule.Editor



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/form/tiny-mce/tiny-mce-helper/tiny-mce.module.ts